export enum PreferredLabName
{
    name = "<span> DaVita Labs </span> <br><span> 3000 DaVita Way </span><br><span> DeLand, Florida, 32724 </span> <br><span> Phone: (866) 909-5227</span><br><span> CLIA# 10D2154944 MEDICARE#L8768</span><span><br> Medical Director Jameel Iqbal, MD</span>", 
}